// extracted by mini-css-extract-plugin
export default {"container":"change-users__container--uB5Yb","info":"change-users__info--s1_j7"};